<app-base-toolbar />

<ion-content>
  <app-login-modal #appLoginModal />
</ion-content>
